export class JsonArraySkipPlaceholder {
    arrayName: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    fullMatch: string = '';

    constructor() {}
}
